import FlashSaleProgress from '@/_application/modules/flash-sales/components/flash-sale-progress';
import {FlashSaleProductData} from '__generated__/__types__';

export const FlashSaleInfo = ({data}: {data: FlashSaleProductData}) => {
    return <FlashSaleProgress flashSaleData={data} className={'mt-[0.3rem]'} />;
};
